import { createStore } from '@stencil/store';
import { Facet } from '~model/search/facets';
import { Result } from '~model/search/result';
import { SearchLinks } from '~model/search/search';
import { Sorting } from '~model/search/sorting';
import { getConfig } from '~service/config-service';
import { HistoryService } from '~service/history-service';

const params = new URLSearchParams(window.location.search);

interface SearchState {
  q: string;
  searchUrl: string;
  suggestUrl: string;
  allJobs: string;
  result: Result;
  facet: Facet[];
  link: SearchLinks;
  facilityLabel: string;
  sorting: Sorting[];
}

const { state, onChange } = createStore({
  q: '',
  searchUrl: getConfig('search.searchUrl', ''),
  suggestUrl: getConfig('search.suggestUrl', ''),
  allJobs: getConfig('search.allJobs', ''),
  result: {
    items: [],
    groups: [],
    limit: 0,
    offset: 0,
    q: '',
    totalResults: 0,
  },
  facet: [],
  link: null,
  facilityLabel: getConfig('search.facilityLabel', ''),
  telefonliste: getConfig('search.telefonliste', window.location.href),
  sorting: null,
} as SearchState);

onChange('q', (q: string) => {
  HistoryService.addArgumentToUrl(window.location.href, { 'tx_solr[q]': q });
});

state.q = params.has('tx_solr[q]') ? params.get('tx_solr[q]') : '';

export default state;
